"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSchemaFromChangeSet = exports.changeSetChangedCount = exports.changeSetContainsChanges = exports.changeSetInsertDocuments = exports.changeSetInsertNewRow = exports.getChangeSetInsertedRows = exports.deleteChangeSetRows = exports.revertChangeSetRowChanges = exports.changeSetToSql = exports.extractChangeSetCondition = exports.batchUpdateChangeSet = exports.setChangeSetRowData = exports.setChangeSetValue = exports.findExistingChangeSetItem = exports.createChangeSet = void 0;
const lodash_1 = __importDefault(require("lodash"));
function createChangeSet() {
    return {
        inserts: [],
        updates: [],
        deletes: [],
    };
}
exports.createChangeSet = createChangeSet;
function findExistingChangeSetItem(changeSet, definition) {
    if (!changeSet || !definition)
        return ['updates', null];
    if (definition.insertedRowIndex != null) {
        return [
            'inserts',
            changeSet.inserts.find(x => x.pureName == definition.pureName &&
                x.schemaName == definition.schemaName &&
                x.insertedRowIndex == definition.insertedRowIndex),
        ];
    }
    else {
        const inUpdates = changeSet.updates.find(x => x.pureName == definition.pureName &&
            x.schemaName == definition.schemaName &&
            ((definition.existingRowIndex != null && x.existingRowIndex == definition.existingRowIndex) ||
                (definition.existingRowIndex == null && lodash_1.default.isEqual(x.condition, definition.condition))));
        if (inUpdates)
            return ['updates', inUpdates];
        const inDeletes = changeSet.deletes.find(x => x.pureName == definition.pureName &&
            x.schemaName == definition.schemaName &&
            ((definition.existingRowIndex != null && x.existingRowIndex == definition.existingRowIndex) ||
                (definition.existingRowIndex == null && lodash_1.default.isEqual(x.condition, definition.condition))));
        if (inDeletes)
            return ['deletes', inDeletes];
        return ['updates', null];
    }
}
exports.findExistingChangeSetItem = findExistingChangeSetItem;
function setChangeSetValue(changeSet, definition, value) {
    if (!changeSet || !definition)
        return changeSet;
    let [fieldName, existingItem] = findExistingChangeSetItem(changeSet, definition);
    if (fieldName == 'deletes') {
        changeSet = revertChangeSetRowChanges(changeSet, definition);
        [fieldName, existingItem] = findExistingChangeSetItem(changeSet, definition);
    }
    if (existingItem) {
        return Object.assign(Object.assign({}, changeSet), { [fieldName]: changeSet[fieldName].map(item => item == existingItem
                ? Object.assign(Object.assign({}, item), { fields: Object.assign(Object.assign({}, item.fields), { [definition.uniqueName]: value }) }) : item) });
    }
    return Object.assign(Object.assign({}, changeSet), { [fieldName]: [
            ...changeSet[fieldName],
            {
                pureName: definition.pureName,
                schemaName: definition.schemaName,
                condition: definition.condition,
                insertedRowIndex: definition.insertedRowIndex,
                existingRowIndex: definition.existingRowIndex,
                fields: {
                    [definition.uniqueName]: value,
                },
            },
        ] });
}
exports.setChangeSetValue = setChangeSetValue;
function setChangeSetRowData(changeSet, definition, document) {
    if (!changeSet || !definition)
        return changeSet;
    let [fieldName, existingItem] = findExistingChangeSetItem(changeSet, definition);
    if (fieldName == 'deletes') {
        changeSet = revertChangeSetRowChanges(changeSet, definition);
        [fieldName, existingItem] = findExistingChangeSetItem(changeSet, definition);
    }
    if (existingItem) {
        return Object.assign(Object.assign({}, changeSet), { [fieldName]: changeSet[fieldName].map(item => item == existingItem
                ? Object.assign(Object.assign({}, item), { fields: {}, document }) : item) });
    }
    return Object.assign(Object.assign({}, changeSet), { [fieldName]: [
            ...changeSet[fieldName],
            {
                pureName: definition.pureName,
                schemaName: definition.schemaName,
                condition: definition.condition,
                insertedRowIndex: definition.insertedRowIndex,
                existingRowIndex: definition.existingRowIndex,
                document,
            },
        ] });
}
exports.setChangeSetRowData = setChangeSetRowData;
// export function batchUpdateChangeSet(
//   changeSet: ChangeSet,
//   rowDefinitions: ChangeSetRowDefinition[],
//   dataRows: []
// ): ChangeSet {
//   const res = {
//     updates: [...changeSet.updates],
//     deletes: [...changeSet.deletes],
//     inserts: [...changeSet.inserts],
//   };
//   const rowItems: ChangeSetItem[] = rowDefinitions.map(definition => {
//     let [field, item] = findExistingChangeSetItem(res, definition);
//     let createUpdate = false;
//     if (field == 'deletes') {
//       res.deletes = res.deletes.filter(x => x != item);
//       createUpdate = true;
//     }
//     if (field == 'updates' && item == null) {
//       item = {
//         ...definition,
//         fields: {},
//       };
//       res.updates.push(item);
//     }
//     return item;
//   });
//   for (const tuple in _.zip(rowItems, dataRows)) {
//     const [definition, dataRow] = tuple;
//     for
//   }
//   return res;
// }
function batchUpdateChangeSet(changeSet, rowDefinitions, dataRows) {
    // console.log('batchUpdateChangeSet', changeSet, rowDefinitions, dataRows);
    for (const tuple of lodash_1.default.zip(rowDefinitions, dataRows)) {
        const [definition, dataRow] = tuple;
        for (const key of lodash_1.default.keys(dataRow)) {
            changeSet = setChangeSetValue(changeSet, Object.assign(Object.assign({}, definition), { columnName: key, uniqueName: key }), dataRow[key]);
        }
    }
    return changeSet;
}
exports.batchUpdateChangeSet = batchUpdateChangeSet;
function extractFields(item, allowNulls = true, allowedDocumentColumns = []) {
    const allFields = Object.assign({}, item.fields);
    for (const docField in item.document || {}) {
        if (allowedDocumentColumns.includes(docField)) {
            allFields[docField] = item.document[docField];
        }
    }
    return lodash_1.default.keys(allFields)
        .filter(targetColumn => allowNulls || allFields[targetColumn] != null)
        .map(targetColumn => ({
        targetColumn,
        exprType: 'value',
        value: allFields[targetColumn],
    }));
}
function changeSetInsertToSql(item, dbinfo = null) {
    var _a, _b;
    const table = (_a = dbinfo === null || dbinfo === void 0 ? void 0 : dbinfo.tables) === null || _a === void 0 ? void 0 : _a.find(x => x.schemaName == item.schemaName && x.pureName == item.pureName);
    const fields = extractFields(item, false, (_b = table === null || table === void 0 ? void 0 : table.columns) === null || _b === void 0 ? void 0 : _b.map(x => x.columnName));
    if (fields.length == 0)
        return null;
    let autoInc = false;
    if (table) {
        const autoIncCol = table.columns.find(x => x.autoIncrement);
        // console.log('autoIncCol', autoIncCol);
        if (autoIncCol && fields.find(x => x.targetColumn == autoIncCol.columnName)) {
            autoInc = true;
        }
    }
    const targetTable = {
        pureName: item.pureName,
        schemaName: item.schemaName,
    };
    return [
        autoInc
            ? {
                targetTable,
                commandType: 'allowIdentityInsert',
                allow: true,
            }
            : null,
        {
            targetTable,
            commandType: 'insert',
            fields,
            insertWhereNotExistsCondition: item.insertIfNotExistsFields
                ? compileSimpleChangeSetCondition(item.insertIfNotExistsFields)
                : null,
        },
        autoInc
            ? {
                targetTable,
                commandType: 'allowIdentityInsert',
                allow: false,
            }
            : null,
    ];
}
function extractChangeSetCondition(item, alias) {
    function getColumnCondition(columnName) {
        const value = item.condition[columnName];
        const expr = {
            exprType: 'column',
            columnName,
            source: {
                name: {
                    pureName: item.pureName,
                    schemaName: item.schemaName,
                },
                alias,
            },
        };
        if (value == null) {
            return {
                conditionType: 'isNull',
                expr,
            };
        }
        else {
            return {
                conditionType: 'binary',
                operator: '=',
                left: expr,
                right: {
                    exprType: 'value',
                    value,
                },
            };
        }
    }
    return {
        conditionType: 'and',
        conditions: lodash_1.default.keys(item.condition).map(columnName => getColumnCondition(columnName)),
    };
}
exports.extractChangeSetCondition = extractChangeSetCondition;
function compileSimpleChangeSetCondition(fields) {
    function getColumnCondition(columnName) {
        const value = fields[columnName];
        const expr = {
            exprType: 'column',
            columnName,
        };
        if (value == null) {
            return {
                conditionType: 'isNull',
                expr,
            };
        }
        else {
            return {
                conditionType: 'binary',
                operator: '=',
                left: expr,
                right: {
                    exprType: 'value',
                    value,
                },
            };
        }
    }
    return {
        conditionType: 'and',
        conditions: lodash_1.default.keys(fields).map(columnName => getColumnCondition(columnName)),
    };
}
function changeSetUpdateToSql(item, dbinfo = null) {
    var _a, _b, _c;
    const table = (_a = dbinfo === null || dbinfo === void 0 ? void 0 : dbinfo.tables) === null || _a === void 0 ? void 0 : _a.find(x => x.schemaName == item.schemaName && x.pureName == item.pureName);
    const autoIncCol = (_b = table === null || table === void 0 ? void 0 : table.columns) === null || _b === void 0 ? void 0 : _b.find(x => x.autoIncrement);
    return {
        from: {
            name: {
                pureName: item.pureName,
                schemaName: item.schemaName,
            },
        },
        commandType: 'update',
        fields: extractFields(item, true, (_c = table === null || table === void 0 ? void 0 : table.columns) === null || _c === void 0 ? void 0 : _c.map(x => x.columnName).filter(x => x != (autoIncCol === null || autoIncCol === void 0 ? void 0 : autoIncCol.columnName))),
        where: extractChangeSetCondition(item),
    };
}
function changeSetDeleteToSql(item) {
    return {
        from: {
            name: {
                pureName: item.pureName,
                schemaName: item.schemaName,
            },
        },
        commandType: 'delete',
        where: extractChangeSetCondition(item),
    };
}
function changeSetToSql(changeSet, dbinfo) {
    return lodash_1.default.compact(lodash_1.default.flatten([
        ...changeSet.inserts.map(item => changeSetInsertToSql(item, dbinfo)),
        ...changeSet.updates.map(item => changeSetUpdateToSql(item, dbinfo)),
        ...changeSet.deletes.map(changeSetDeleteToSql),
    ]));
}
exports.changeSetToSql = changeSetToSql;
function revertChangeSetRowChanges(changeSet, definition) {
    // console.log('definition', definition);
    const [field, item] = findExistingChangeSetItem(changeSet, definition);
    // console.log('field, item', field, item);
    // console.log('changeSet[field]', changeSet[field]);
    // console.log('changeSet[field] filtered', changeSet[field].filter((x) => x != item);
    if (item)
        return Object.assign(Object.assign({}, changeSet), { [field]: changeSet[field].filter(x => x != item) });
    return changeSet;
}
exports.revertChangeSetRowChanges = revertChangeSetRowChanges;
function consolidateInsertIndexes(changeSet, name) {
    const indexes = changeSet.inserts
        .filter(x => x.pureName == name.pureName && x.schemaName == name.schemaName)
        .map(x => x.insertedRowIndex);
    indexes.sort((a, b) => a - b);
    if (indexes[indexes.length - 1] != indexes.length - 1) {
        return Object.assign(Object.assign({}, changeSet), { inserts: changeSet.inserts.map(x => (Object.assign(Object.assign({}, x), { insertedRowIndex: indexes.indexOf(x.insertedRowIndex) }))) });
    }
    return changeSet;
}
function deleteChangeSetRows(changeSet, definition) {
    let [fieldName, existingItem] = findExistingChangeSetItem(changeSet, definition);
    if (fieldName == 'updates') {
        changeSet = revertChangeSetRowChanges(changeSet, definition);
        [fieldName, existingItem] = findExistingChangeSetItem(changeSet, definition);
    }
    if (fieldName == 'inserts') {
        return consolidateInsertIndexes(revertChangeSetRowChanges(changeSet, definition), definition);
    }
    else {
        if (existingItem && fieldName == 'deletes')
            return changeSet;
        return Object.assign(Object.assign({}, changeSet), { deletes: [
                ...changeSet.deletes,
                {
                    pureName: definition.pureName,
                    schemaName: definition.schemaName,
                    condition: definition.condition,
                    existingRowIndex: definition.existingRowIndex,
                },
            ] });
    }
}
exports.deleteChangeSetRows = deleteChangeSetRows;
function getChangeSetInsertedRows(changeSet, name) {
    var _a;
    // if (!name) return [];
    if (!changeSet)
        return [];
    const rows = changeSet.inserts.filter(x => name == null || (x.pureName == name.pureName && x.schemaName == name.schemaName));
    const maxIndex = (_a = lodash_1.default.maxBy(rows, x => x.insertedRowIndex)) === null || _a === void 0 ? void 0 : _a.insertedRowIndex;
    if (maxIndex == null)
        return [];
    const res = Array(maxIndex + 1).fill({});
    for (const row of rows) {
        res[row.insertedRowIndex] = row.fields;
    }
    return res;
}
exports.getChangeSetInsertedRows = getChangeSetInsertedRows;
function changeSetInsertNewRow(changeSet, name) {
    // console.log('INSERT', name);
    const insertedRows = getChangeSetInsertedRows(changeSet, name);
    return Object.assign(Object.assign({}, changeSet), { inserts: [
            ...changeSet.inserts,
            Object.assign(Object.assign({}, name), { insertedRowIndex: insertedRows.length, fields: {} }),
        ] });
}
exports.changeSetInsertNewRow = changeSetInsertNewRow;
function changeSetInsertDocuments(changeSet, documents, name, insertIfNotExistsFieldNames) {
    const insertedRows = getChangeSetInsertedRows(changeSet, name);
    return Object.assign(Object.assign({}, changeSet), { inserts: [
            ...changeSet.inserts,
            ...documents.map((doc, index) => (Object.assign(Object.assign({}, name), { insertedRowIndex: insertedRows.length + index, fields: doc, insertIfNotExistsFields: insertIfNotExistsFieldNames ? lodash_1.default.pick(doc, insertIfNotExistsFieldNames) : null }))),
        ] });
}
exports.changeSetInsertDocuments = changeSetInsertDocuments;
function changeSetContainsChanges(changeSet) {
    var _a;
    if (!changeSet)
        return false;
    return (changeSet.deletes.length > 0 ||
        changeSet.updates.length > 0 ||
        changeSet.inserts.length > 0 ||
        !!changeSet.structure ||
        !!changeSet.setColumnMode ||
        ((_a = changeSet.dataUpdateCommands) === null || _a === void 0 ? void 0 : _a.length) > 0);
}
exports.changeSetContainsChanges = changeSetContainsChanges;
function changeSetChangedCount(changeSet) {
    return changeSet.deletes.length + changeSet.updates.length + changeSet.inserts.length;
}
exports.changeSetChangedCount = changeSetChangedCount;
function removeSchemaFromChangeSet(changeSet) {
    return Object.assign(Object.assign({}, changeSet), { inserts: changeSet.inserts.map(x => (Object.assign(Object.assign({}, x), { schemaName: undefined }))), updates: changeSet.updates.map(x => (Object.assign(Object.assign({}, x), { schemaName: undefined }))), deletes: changeSet.deletes.map(x => (Object.assign(Object.assign({}, x), { schemaName: undefined }))) });
}
exports.removeSchemaFromChangeSet = removeSchemaFromChangeSet;
